export default "__VITE_ASSET__4i_Gu393__"